import {cssTheme} from '../theme'
import {css} from '../theme/css'
import {breakpoints, spacing} from '../theme/theme'

export const layoutClasses = {
  layout: css`
    flex: 1;
  `,
  layoutSidebar: css`
    display: flex;
  `,
  minor: css`
    background-color: ${cssTheme.default.day.backgroundMinor};
  `,
}

export const contentClasses = {
  root: css`
    padding-block-start: ${spacing(3)};
    padding-inline: ${spacing(2)};
    margin-inline: auto;
    inline-size: 100%;
    max-inline-size: 1280px;

    ${breakpoints.up('sm')} {
      padding-inline: ${spacing(3)};
    }
  `,
}

export const headerClasses = {
  root: css`
    padding-block-end: ${spacing(3)};

    ${breakpoints.down('sm')} {
      padding-block-end: ${spacing(2)};
    }
  `,
}

export const sidebarClasses = {
  leftSidebar: css`
    background-color: ${cssTheme.default.day.background};
    border-right: 1px solid ${cssTheme.colors.warmGray[150]};
    padding-inline-start: ${spacing(3)};
    padding-top: ${spacing(4)};
    box-sizing: border-box;
    inline-size: 278px;
    flex-shrink: 0;

    ${breakpoints.down('sm')} {
      display: none;
    }
  `,
}

export const footerClasses = {
  root: css`
    top: auto !important;
    bottom: 0;
    border-top-left-radius: ${spacing(2)};
    border-top-right-radius: ${spacing(2)};
    padding: ${spacing(2.5, 0)};
  `,
}
